// extracted by mini-css-extract-plugin
module.exports = {"phone":"styles_phone__10y0K","phone-input":"styles_phone-input__VfQM5","code-input":"styles_code-input__qJ4EP","link":"styles_link__nnlh4","timing":"styles_timing__x2Vbf"};